export const xeroAPIUrls = {
  xeroConnect: '/xero/connect',
  xeroDisconnect: '/xero/disconnect',
  xeroStatus: '/xero/check-status',
};
